enum Global {
  SET_GLOBAL_INITIALIZE = 'SET_GLOBAL_INITIALIZE',
  SET_GLOBAL_LOADING = 'SET_GLOBAL_LOADING',
  SET_GLOBAL_SIDE_BAR = 'SET_GLOBAL_SIDE_BAR',
  SET_GLOBAL_SIDE_BAR_STATIC = 'SET_GLOBAL_SIDE_BAR_STATIC',
  SET_GLOBAL_HEADER = 'SET_GLOBAL_HEADER',
  SET_GLOBAL_THEME = 'SET_GLOBAL_THEME',
  SET_GLOBAL_HISTORIES = 'SET_GLOBAL_HISTORIES',
  SET_GLOBAL_ROLE_SELECT = 'SET_GLOBAL_ROLE_SELECT',
  SET_GLOBAL_FONT_SCALE = 'SET_GLOBAL_FONT_SCALE',
  SET_GLOBAL_LANG = 'SET_GLOBAL_LANG'
}

export default Global;
